import Config from '../config/constants';


interface FacebookStatus {
  isConnected: boolean;
  userInfo?: {
    id: string;
    name: string;
    email?: string;
  };
  timestamp: number;
}


class FacebookStatusCache {
  private cache: Map<number, FacebookStatus> = new Map();
  private readonly CACHE_DURATION = 5 * 60 * 1000; // 5분

  async getStatus(
    branchId: number,
    forceRefresh: boolean = false,
  ): Promise<FacebookStatus | null> {
    const cached = this.cache.get(branchId);
    const now = Date.now();

    // 캐시가 유효하고 강제 새로고침이 아닌 경우 캐시 반환
    if (
      !forceRefresh &&
      cached &&
      now - cached.timestamp < this.CACHE_DURATION
    ) {
      console.log('📘 Facebook 상태 캐시 사용:', { branchId, cached: true });
      return cached;
    }

    // API 호출하여 상태 확인
    try {
      console.log('📘 Facebook 상태 API 호출:', { branchId, forceRefresh });
      const apiUrl = `${Config.API_HOST}/api/facebook-oauth/status?userId=${branchId}`;
      const response = await fetch(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        const status: FacebookStatus = {
          isConnected: data.isConnected,
          userInfo: data.userInfo,
          timestamp: now,
        };

        // 캐시에 저장
        this.cache.set(branchId, status);
        console.log('📘 Facebook 상태 캐시 업데이트:', {
          branchId,
          isConnected: status.isConnected,
        });

        return status;
      } else {
        console.error('❌ Facebook 상태 확인 실패:', response.status);
        return null;
      }
    } catch (error) {
      console.error('❌ Facebook 상태 확인 오류:', error);
      return null;
    }
  }

  // 캐시 무효화 (연결/해제 시 사용)
  invalidateCache(branchId: number) {
    this.cache.delete(branchId);
    console.log('📘 Facebook 상태 캐시 무효화:', { branchId });
  }

  // 전체 캐시 초기화
  clearCache() {
    this.cache.clear();
    console.log('📘 Facebook 상태 캐시 전체 초기화');
  }

  // 캐시된 상태 직접 설정 (연결/해제 후 즉시 반영용)
  setStatus(branchId: number, isConnected: boolean, userInfo?: any) {
    const status: FacebookStatus = {
      isConnected,
      userInfo,
      timestamp: Date.now(),
    };
    this.cache.set(branchId, status);
    console.log('📘 Facebook 상태 캐시 직접 설정:', { branchId, isConnected });
  }
}

// 싱글톤 인스턴스
export const facebookStatusCache = new FacebookStatusCache();
